import { inject, signal } from '@angular/core';
import { ComponentGlobalConfig } from './config.interface';
import { COMPONENT_GLOBAL_CONFIG_TOKEN } from './token.type';

export class BaseConfig {
  protected readonly globalConfig = signal<ComponentGlobalConfig>({});

  constructor() {
    const _globalConfig = inject(COMPONENT_GLOBAL_CONFIG_TOKEN, {
      optional: true,
    });

    if (_globalConfig) {
      this.globalConfig.set(_globalConfig);
    }
  }
}
